module.exports = __webpack_public_path__ + "img/40_38_035_510.7be9d08d.jpg";